module.exports = __webpack_public_path__ + "img/loading.03d288f8.gif";